import { HttpRequest } from "@/utils/request"

export const logService = {
  listSearchLogs(params: any) {
    return HttpRequest.get("v1/search-logs", {
      searchParams: params as any,
    }).json<{
      code: number
      data: any[]
      total: number
      page: number
      limit: number
    }>()
  },
  listAddVocabularyLogs(params: any) {
    return HttpRequest.get("v1/add-vocabulary-logs", {
      searchParams: params as any,
    }).json<{
      code: number
      data: any[]
      total: number
      page: number
      limit: number
    }>()
  },
  listSrsLogs(params: any) {
    return HttpRequest.get("v1/srs-logs", {
      searchParams: params as any,
    }).json<{
      code: number
      data: any[]
      total: number
      page: number
      limit: number
    }>()
  },
  listReadingPracticeLogs(params: any) {
    return HttpRequest.get("v1/reading-practice-logs", {
      searchParams: params as any,
    }).json<{
      code: number
      data: any[]
      total: number
      page: number
      limit: number
    }>()
  },
}
